import {
    ArticlePhotosState,
    initialArticlePhotosState,
} from "@/mk2/apps/wiki/containers/ArticlePhoto/ArticlePhoto.reducers";
import { AppState } from "@/mk2/reducers";

export const geArticlePhotosState = (
    state: AppState,
    categorySlug: string,
    articleSlug: string,
): ArticlePhotosState =>
    state.containers.wiki.articlesPhotos[`${categorySlug}/${articleSlug}`] ||
    initialArticlePhotosState;
